import { Injectable, inject, signal } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';


@Injectable({ providedIn: 'root' })
export class SubscriptionSettingsService {

  private readonly _shared = inject(SharedService);

  /* A signal rather than a plain field so a `computed` that reads any of the
     getters below re-runs when the bootstrap answers. The plan editor's
     validation is one, and it would otherwise be stuck on whatever was known
     the first time it happened to be evaluated. */
  private readonly settings = signal<any>({});

  /** Whether the profile bootstrap has answered yet. */
  private get loaded(): boolean {
    return Object.keys(this.settings()).length > 0;
  }

  constructor() {
    this._shared.doctorSettings$.subscribe(settings => this.settings.set(settings || {}));
  }


  get enabled(): boolean {
    if (!this.loaded) { return true; }
    return Number(this.settings().sub_show_process_payment) === 1;
  }
  get restricted(): boolean {
    return Number(this.settings().sub_pp_restricted) === 1;
  }

  /** The message `pp_restricted` shows in Payment Process, unchanged. */
  readonly restrictedMessage =
    'Please use Have us call you back or contact us at support@financemutual.com to enable Subscription feature.';

  /** Smallest chargeable amount, or 0 for no floor. */
  get minAmount(): number {
    return Number(this.settings().sub_min_process_amount) || 0;
  }

  /** Largest chargeable amount, or 0 for no ceiling. */
  get maxAmount(): number {
    return Number(this.settings().sub_single_transaction_max_amount) || 0;
  }
  get showRefund(): boolean {
    return Number(this.settings().sub_show_reverse) === 1;
  }
  get canCancel(): boolean {
    return Number(this.settings().sub_can_cancel) === 1;
  }

  /**
   * This reads at both the plan editor (where "amount" is the price being
   * typed in) and the payment flow (where it is a fixed, already-published
   * plan's price) — so the fix-it clause has to hold for either: "choose a
   * smaller plan" was wrong on two counts inside the editor, since there is no
   * other plan to choose and, on the minimum branch, smaller is the wrong
   * direction entirely.
   */
  amountRefusal(amount: number, currencySign = '$'): string {
    if (!this.loaded || !(amount > 0)) { return ''; }
    if (this.minAmount && amount < this.minAmount) {
      return `This business's minimum per-transaction amount is ${currencySign}${this.minAmount}. Please contact support, or increase the amount.`;
    }
    if (this.maxAmount && amount > this.maxAmount) {
      return `This business's maximum per-transaction amount is ${currencySign}${this.maxAmount}. Please contact support, or reduce the amount.`;
    }
    return '';
  }
}
